export enum SerialScaleUnit {
  KILOGRAM = "KILOGRAM",
  HECTOGRAM = "HECTOGRAM",
  GRAM = "GRAM",
}
